import React from 'react';
import { Link } from 'gatsby';

export const find_tenants_faqs = [
  {
    title: 'How do you make sure that I find tenants fast?',
    body:
      "We advertise our properties on all of the major property letting site such as Rightmove and Zoopla, ensuring that your property is competing in the best places that tenants search for. What's more, we'll stage your property and take beautiful images of it to ensure that it is standing out from the crowd.",
  },
  {
    title: 'What do you mean by “Staging” my property?',
    body:
      "We'll visit the property and make sure it is laid out in a way that is pleasing to the eye. Think if it as a property marketing feng shui. Once your property is looking at its absolute best, our professional photographers will capture it in all its glory!",
  },
  {
    title:
      "I've had a bad experience with agents managing viewings before, how are you any different?",
    body:
      'As we are an online letting agency, we use automation systems, reference codes and AI so that potential tenants can book a viewing over the phone with an automated system. This then notifies our operations team who will ensure that someone is there to meet the potential tenants and show them around the property.',
  },
  {
    title:
      "I've had agents take photos of my properties before and they were AWFUL! How can I trust you'll do a good job?",
    body:
      "We feel your pain! We know how important it is to maximise the letting potential of your property. That's why we employ professional photographers to take photos of Oasis Living properties. This comes as a standard service when you let through Oasis Living, no premium add on costs. Just great photos of your property. We'll ensure your property stands out from the crowd on all the letting sites like Rightmove, Zoopla and more. No more ugly camera phone pictures!",
  },
  {
    title:
      'So you can find tenants for me. What about managing my property as well? ',
    body: (
      <div>
        Good news! We can also manage your property for you! Our fully let and
        managed service will take care of everything for you and give you a
        dashboard so you can keep up to date on it all! Check out our{' '}
        <Link to="/landlord/property-management/">
          property management page
        </Link>{' '}
        to see how we help your property business grow for just 10% of the
        letting price of the property!
      </div>
    ),
  },
];
